<template v-cloak>
    <NuxtLayout name="main" :class="i18n.locale.value === 'en' ? 'en' : 'zh'">
        <section class="header-container">
            <div class="title font-bold container">{{ $t("PrivacyI18n.Title") }}</div>
        </section>

        <section class="info-container">
            <div class="container">{{ $t("PrivacyI18n.RecentUpdates") }}{{ $t("PrivacyI18n.RecentUpdatesData") }}</div>
        </section>

        <section class="content-container container">
            <div class="paragraph">
                <div class="descript" v-html="$t('PrivacyI18n.Descript1')"></div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript2')"></div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript3')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section1')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript4')"></div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript5')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section2')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript6')"></div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript7')"></div>
                <div div class="descript-group">
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript8')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript9')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript10')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript11')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript12')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript13')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript14')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript15')"></div>
                </div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript16')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section3')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript17')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section4')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript18')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section5')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript19')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section6')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript20')"></div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript21')"></div>
                <div div class="descript-group">
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript22')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript23')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript24')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript25')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript26')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript27')"></div>
                </div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript28')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section7')"></h2>
                <div class="descript" v-html="$t('PrivacyI18n.Descript29')"></div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section8')"></h2>
                <div class="descript-item-text" v-html="$t('PrivacyI18n.Descript30')"></div>
                <div div class="descript-group">
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript31')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript32')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript33')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript34')"></div>
                    <div class="descript-item" v-html="$t('PrivacyI18n.Descript35')"></div>
                </div>
            </div>
            <div class="paragraph">
                <h2 class="title-5" v-html="$t('PrivacyI18n.Section9')"></h2>
                <div v-if="i18n.locale.value === 'zh'" class="descript" v-html="$t('PrivacyI18n.Descript36')"></div>
                <div class="descript-item-text" v-html="$t('PrivacyI18n.Descript37')"></div>
                <div class="descript-group descript-group-2">
                    <div class="descript-item font-bold" v-html="$t('PrivacyI18n.Descript38')"></div>
                    <div class="descript-item font-bold" v-html="$t('PrivacyI18n.Descript39')"></div>
                    <div v-if="i18n.locale.value === 'zh'" class="descript-item font-bold" v-html="$t('PrivacyI18n.Descript40')"></div>
                </div>
                <div class="descript" v-html="$t('PrivacyI18n.Descript41')"></div>
            </div>
        </section>
    </NuxtLayout>
</template>

<script lang="ts" setup>
const i18n = useI18n();
</script>

<style lang="less" scoped>
// 中文格式
.zh {
    --em: 2em;
    --item-em: 1.5em;
}

// 英文格式
.en {
    --em: 0em;
    --item-em: 1.2em;
}

.header-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 240px;
    background: url("@/assets/images/privacy/header-cover.png") center no-repeat;
    background-size: cover;

    .title {
        font-size: 30px;
        color: #ffffff;
    }
}

.info-container {
    display: flex;
    align-items: center;
    width: 100%;
    height: 64px;
    background-color: var(--uicolor-font-5);
}

.content-container {
    margin: 64px auto 0;

    *:last-child {
        margin-bottom: 0 !important;
    }

    .paragraph {
        margin: 0 0 64px;

        *:last-child {
            margin-bottom: 0;
        }
    }

    h2 {
        position: relative;
        display: flex;
        align-items: center;
        margin: 0 0 32px;
        color: var(--uicolor-font-1);
        padding-left: 16px;

        &::before {
            position: absolute;
            top: 0;
            left: 0;
            content: "";
            width: 16px;
            height: 34px;
            background: url("@/assets/images/privacy/icon-item.png") center no-repeat;
            background-size: contain;
        }
    }

    .descript {
        margin: 0 0 32px;
        text-indent: var(--em);
    }

    .descript-item-text {
        margin: 0 0 8px;
        text-indent: var(--em);
    }

    .descript-group {
        margin: 0 0 32px var(--em);

        &-2 {
            margin: 0 0 32px calc(var(--em) + var(--item-em));
        }
    }

    .descript-item {
        margin: 0 0 8px var(--item-em);
        text-indent: calc(-1 * var(--item-em));
        color: var(--uicolor-font-1);
    }
}
</style>
